"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Metadata related to recalculation of a release category. Data should be persisted for each and every category recalculation.</p>
 *
 * @author Jan Gregor
 * @author Jaroslav Sevcik
 */


var ReleasePriceCalculation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleasePriceCalculation, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id
   * @param releaseId
   * @param productCategoryId
   * @param priceZoneId
   * @param releaseItemIds
   * @param settings Settings which were used for this calculations. May be suitable only for some kind of releases.
   * @param groupId Identification of an arbitrary group of calculations. Typically this will be ID of the workflow case inside which
   *        the calculation was created. There can be many calculations in one optimization task and there can also be many optimization
   *        tasks (e.g. recalculations). So this attribute serves for an identification of calculations which belongs together. For
   *        example we must be able to find calculations for current recalculation.
   * @param calculatorName
   * @param lastOutput Last known state (and possibly additional data) of this calculation. It should be always defined after
   *        the described calculation was started.
   * @param lastOutputTime
   * @param preserveManualPrices Nullable because historical calculation does not use this settings. If type of release supports
   *        'manual prices' calculation mode, this value should be always set for newly created calculations.
   */
  function ReleasePriceCalculation(id, releaseId, productCategoryId, priceZoneId, releaseItemIds, settings, groupId, calculatorName, lastOutput, lastOutputTime, preserveManualPrices) {
    var _this;

    _classCallCheck(this, ReleasePriceCalculation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePriceCalculation).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.productCategoryId = productCategoryId;
    _this.priceZoneId = priceZoneId;
    _this.releaseItemIds = releaseItemIds;
    _this.settings = settings;
    _this.groupId = groupId;
    _this.calculatorName = calculatorName;
    _this.lastOutput = lastOutput;
    _this.lastOutputTime = lastOutputTime;
    _this.preserveManualPrices = preserveManualPrices;
    return _this;
  }

  return ReleasePriceCalculation;
}(DomainObject_1.DomainObject);

exports.ReleasePriceCalculation = ReleasePriceCalculation;